export const types = {
  CATIZ_INTERNAL_CHANGE_TP_STATE: 'CATIZ_INTERNAL_CHANGE_TP_STATE',
};

export const setCatizInternalChangeTPState_AC = (
  panelSetType: string,
  panelValue: string
) => {
  return {
    type: types.CATIZ_INTERNAL_CHANGE_TP_STATE,
    payload: {
      panelSetType,
      panelValue,
    },
  };
};
